import React from 'react'

import './member-subscription.scss'
import { ReactComponent as SubIcon } from 'assets/img/subscription.svg'
import moment from 'moment'
import miscUtils from 'utils/miscUtils'
import { AdminMemberDetailsContext } from '../AdminMemberDetails'
import ContentLoader from 'react-content-loader'
import GroupSubscriptionMembersModal from 'containers/ManageSubscription/GroupSubscriptionMembersModal'
import { toast } from 'react-toastify'

const SubscriptionMemberDetails = ({ 
    userMembership, 
    group,
    fetchUserMembershipDetails,
}: { 
    userMembership: any,
    fetchUserMembershipDetails?: any,
    group?: any 
}) => {

    const { isLoading, settingsPage } = React.useContext(AdminMemberDetailsContext)

    const [isMembersModalOpen, setIsMembersModalOpen] = React.useState<boolean>(false);

    const formatBillingInterval = (sub: any) => {
        if (sub.interval === "one_time") {
            return "One time"
        }

        if(sub.interval === "week") {
            return "Weekly";
        }

        if (sub.interval === "month") {
            switch (sub.interval_count) {
                case 1:
                    return "Monthly";
                case 3:
                    return "Every 3 months";
                case 6:
                    return "Every 6 months";
                default:
                    return ""
            }
        }

        if (sub.interval === "year") {
            return "Yearly";
        }

        return "";
    }

    const getPlanType = (plan: any) => {
        if(
            plan && 
            plan.collection_type
        ) {
            return `${plan.collection_type.charAt(0).toUpperCase()}${plan.collection_type.slice(1)}`;
        }

        return 'Individual';
    }   


    const isParentGroupSubscription = () => {
        return (
            userMembership &&
            userMembership.active_subscription &&
            userMembership.active_subscription.plan &&
            userMembership.active_subscription.plan.collection_type === 'group' &&
            !userMembership.parent_membership_id 
        )
    }

    const isChildGroupSubscription = () => {
        return (
            userMembership &&
            userMembership.active_subscription &&
            userMembership.active_subscription.plan &&
            userMembership.active_subscription.plan.collection_type === 'group' &&
            userMembership.parent_membership_id 
        )
    } 

    const getParentName = () => {
        if(
            userMembership &&
            userMembership.parent_account &&
            userMembership.parent_account.user
        ) {
            return userMembership.parent_account.user.full_name;
        }

        return ''
    }

    const getParentUserMembershipId = () => {
        if(
            userMembership &&
            userMembership.parent_account &&
            userMembership.parent_account.user &&
            userMembership.parent_account.user.id
        ) {
            return userMembership.parent_account.user.id
        }
        return undefined;
    }

    const navigateToParentProfile = () => {
        if(fetchUserMembershipDetails && getParentUserMembershipId()) {
            fetchUserMembershipDetails(getParentUserMembershipId(), true);
        }
    }

    const getGroupSubscriptionInviteLink = () => {
        if(
            group &&
            group.url &&
            userMembership &&
            userMembership.group_subscription_invitation &&
            userMembership.group_subscription_invitation.slug
        ) {
            return `${group.url}/join_group/${userMembership.group_subscription_invitation.slug}`;
        }

        return '/';
    }

    const getGroupSubscriptionDisplayInviteLink = () => {
        if(
            userMembership &&
            userMembership.group_subscription_invitation &&
            userMembership.group_subscription_invitation.slug
        ) {
            return `/join_group/${userMembership.group_subscription_invitation.slug}`;
        }

        return '/';
    }

    const copyGroupSubscriptionInviteLink = () => {
        navigator.clipboard.writeText(getGroupSubscriptionInviteLink());
        toast("Invite link copied", {
            type: 'success',
            autoClose: 3000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light",
        });
    }

    return (
        <>
        <div className={`member-sub-container ${settingsPage ? 'community-styles' : ''}`}>
            <div className="header">
                <SubIcon />
                <h1>Subscription</h1>
            </div>
            {isLoading ?
                <>
                    {
                        Array(7).fill('').map((_e, i) => (
                            <div
                                style={
                                    {
                                        width: '100%',
                                    }
                                }
                            >
                                <ContentLoader
                                    height={window.innerWidth <= 500 ? 90 : 20}
                                    width={120}
                                    speed={2}
                                    primaryColor="#d9d9d9"
                                    secondaryColor="#ecebeb"
                                    viewBox="0 0 120 20"
                                >
                                    <rect x="0" y="0" rx="2" ry="2" width={60} height={4} />
                                    <rect x="0" y="8" rx="2" ry="2" width={90} height={4} />
                                </ContentLoader>
                            </div>
                        ))}
                </>
                :
                <>
                    {userMembership && userMembership.temp_plan !== null && userMembership.active_subscription === null && userMembership.approved_on ?
                        <div className='body-section'>
                            <div>
                                <span>Plan name</span>
                                <div>
                                    {userMembership.temp_plan.name ?
                                        <h4>{userMembership.temp_plan.name}</h4>
                                        :
                                        <h4> - </h4>
                                    }
                                </div>
                            </div>
                            <div>
                                <span>Plan type</span>
                                <div>
                                    {userMembership.temp_plan ?
                                        <h4>{getPlanType(userMembership.temp_plan)}</h4>
                                        :
                                        <h4> - </h4>
                                    }
                                </div>
                            </div>
                            {!isChildGroupSubscription() ? (
                                <div>
                                    <span>Amount</span>
                                    {userMembership.temp_plan.price ?
                                        <h4>
                                            {miscUtils.getResourceCurrency(userMembership.temp_plan.currency, userMembership.group && userMembership.group.currency)}{" "}
                                            {userMembership.temp_plan.price}
                                        </h4>
                                        :
                                        <h4> - </h4>
                                    }
                                </div>
                            ) : <></>}
                            <div>
                                <span>Status</span>
                                <h4> Canceled </h4>
                            </div>
                            {!isChildGroupSubscription() ? (
                                <div>
                                    <span>Started</span>
                                    {
                                        miscUtils.isMembershipPendingApproval(userMembership)
                                            ?
                                            <h4> - </h4>
                                            :
                                            <h4>
                                                {moment.utc(userMembership.temp_plan.created_at).local().format('MMM D, YYYY')}
                                            </h4>
                                    }

                                </div>
                            ) : <></>}
                            {!isChildGroupSubscription() ? (
                                <div>
                                    <span>Billing cycle</span>
                                    <div>
                                        {userMembership.temp_plan.interval
                                            ?
                                            <h4>{formatBillingInterval(userMembership.temp_plan)}</h4>
                                            :
                                            <h4> - </h4>
                                        }
                                    </div>
                                </div>
                            ) : <></>}
                            {!isChildGroupSubscription() ? (
                                <div>
                                    <span>Next invoice</span>
                                    <h4> - </h4>
                                </div>
                            ) : <></>}
                        </div>

                        :
                        <>
                            {
                                userMembership &&
                                    userMembership.temp_plan !== null &&
                                    userMembership.active_subscription === null
                                    ?
                                    <div className='body-section'>
                                        <div>
                                            <span>Plan name</span>
                                            <div>
                                                {userMembership.temp_plan.name ?
                                                    <h4>{userMembership.temp_plan.name}</h4>
                                                    :
                                                    <h4> - </h4>
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <span>Plan type</span>
                                            <div>
                                                {userMembership.temp_plan ?
                                                    <h4>{getPlanType(userMembership.temp_plan)}</h4>
                                                    :
                                                    <h4> - </h4>
                                                }
                                            </div>
                                        </div>
                                        {!isChildGroupSubscription() ? (
                                            <div>
                                                <span>Amount</span>
                                                {userMembership.temp_plan.price ?
                                                    <h4>
                                                        {miscUtils.getResourceCurrency(userMembership.temp_plan.currency, userMembership.group && userMembership.group.currency)}{" "}
                                                        {userMembership.temp_plan.price}
                                                    </h4>
                                                    :
                                                    <h4> - </h4>
                                                }
                                            </div>
                                        ) : <></>}
                                        <div>
                                            <span>Status</span>
                                            <h4> Pending </h4>
                                        </div>
                                        {!isChildGroupSubscription() ? (
                                            <div>
                                                <span>Started</span>
                                                {
                                                    miscUtils.isMembershipPendingApproval(userMembership)
                                                        ?
                                                        <h4> - </h4>
                                                        :
                                                        <h4>
                                                            {moment.utc(userMembership.temp_plan.created_at).local().format('MMM D, YYYY')}
                                                        </h4>
                                                }

                                            </div>
                                        ) : <></>}
                                        {!isChildGroupSubscription() ? (
                                            <div>
                                                <span>Billing cycle</span>
                                                <div>
                                                    {userMembership.temp_plan.interval
                                                        ?
                                                        <h4>{formatBillingInterval(userMembership.temp_plan)}</h4>
                                                        :
                                                        <h4> - </h4>
                                                    }
                                                </div>
                                            </div>
                                        ) : <></>}
                                        {!isChildGroupSubscription() ? (
                                            <div>
                                                <span>Next invoice</span>
                                                <h4> - </h4>
                                            </div>
                                        ) : <></>}
                                    </div>
                                    :
                                    <>
                                        {
                                            userMembership && userMembership.active_subscription !== null && userMembership.approved_on === null ?
                                                <div className='body-section'>
                                                    <div>
                                                        <span>Plan name</span>
                                                        {
                                                            userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                <>
                                                                    {userMembership.active_subscription ?
                                                                        <h4>
                                                                            {userMembership.active_subscription.plan.name}
                                                                        </h4>
                                                                        :
                                                                        <div>
                                                                            {
                                                                                userMembership.previous_plan ?
                                                                                    <h4>{userMembership.previous_plan.name}</h4>
                                                                                    :
                                                                                    <h4> - </h4>
                                                                            }

                                                                        </div>
                                                                    }
                                                                </>
                                                                :
                                                                <h4> - </h4>
                                                        }
                                                    </div>
                                                    <div>
                                                        <span>Plan type</span>
                                                        {
                                                            userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                <>
                                                                    {
                                                                        userMembership.active_subscription ?
                                                                            <div>
                                                                                {
                                                                                    userMembership.active_subscription.plan
                                                                                        ?
                                                                                        <h4>{getPlanType(userMembership.active_subscription.plan)}</h4>
                                                                                        :
                                                                                        <h4> - </h4>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                {
                                                                                    userMembership.previous_plan ?
                                                                                        <h4>{userMembership.previous_plan}</h4>
                                                                                        :
                                                                                        <h4> - </h4>
                                                                                }

                                                                            </div>
                                                                    }
                                                                </>
                                                                :
                                                                <h4> - </h4>
                                                        }
                                                    </div>
                                                    {
                                                        //for parent group subscriptions, show number of seats
                                                        isParentGroupSubscription() ? (
                                                            <div>
                                                                <span>Seats</span>
                                                                <h4>
                                                                    <span
                                                                    className="clickable-value"
                                                                    onClick={() => setIsMembersModalOpen(true)}
                                                                    >
                                                                        {userMembership.sub_accounts_count + 1}
                                                                        {" "}/{" "}
                                                                        {userMembership.active_subscription.quantity}
                                                                    </span>
                                                                </h4>
                                                            </div>
                                                        ) : <></>
                                                    }
                                                    {
                                                        //for parent group subscriptions, show invite link
                                                        isParentGroupSubscription() ? (
                                                            <div>
                                                                <span>Invite link</span>
                                                                <h4>
                                                                    <span
                                                                    className="clickable-value invite-link"
                                                                    onClick={copyGroupSubscriptionInviteLink}
                                                                    >
                                                                        {getGroupSubscriptionDisplayInviteLink()}
                                                                    </span>
                                                                </h4>
                                                            </div>
                                                        ) : <></>
                                                    }
                                                    {
                                                        //for child group subscriptions, show account owner
                                                        isChildGroupSubscription() ? (
                                                            <div>
                                                                <span>Account owner</span>
                                                                <h4>
                                                                    <span
                                                                    className="clickable-value"
                                                                    onClick={navigateToParentProfile}
                                                                    >{getParentName()}</span>
                                                                </h4>
                                                            </div>
                                                        ) : <></>
                                                    }
                                                    {!isChildGroupSubscription() ? (
                                                        <div>
                                                            <span>Amount</span>
                                                            {
                                                                userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                    <>
                                                                        {
                                                                            userMembership.active_subscription ?
                                                                                <h4>
                                                                                    {miscUtils.getResourceCurrency(userMembership.active_subscription.plan.currency, userMembership.group && userMembership.group.currency)}{" "}
                                                                                    {userMembership.active_subscription.plan.price}
                                                                                </h4>
                                                                                :
                                                                                <div>
                                                                                    {
                                                                                        userMembership.previous_plan ?
                                                                                            <h4>
                                                                                                {miscUtils.getResourceCurrency(userMembership.previous_plan.currency, userMembership.group && userMembership.group.currency)}{" "}
                                                                                                {userMembership.previous_plan.price}
                                                                                            </h4>
                                                                                            :
                                                                                            <h4> - </h4>
                                                                                    }

                                                                                </div>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <h4> - </h4>
                                                            }
                                                        </div>
                                                    ) : <></>}
                                                    <div>
                                                        <span>Status</span>
                                                        <h4> Pending </h4>
                                                    </div>
                                                    {!isChildGroupSubscription() ? (
                                                        <div>
                                                            <span>Started</span>
                                                            <h4> - </h4>
                                                        </div>
                                                    ) : <></>}
                                                    {!isChildGroupSubscription() ? (
                                                        <div>
                                                            <span>Billing cycle</span>
                                                            {
                                                                userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                    <>
                                                                        {
                                                                            userMembership.active_subscription ?
                                                                                <div>
                                                                                    {
                                                                                        userMembership.active_subscription.plan.interval
                                                                                            ?
                                                                                            // <h4>{userMembership.active_subscription.plan.interval.replace(/_/g, " ")}</h4>
                                                                                            <h4>{formatBillingInterval(userMembership.active_subscription.plan)}</h4>
                                                                                            :
                                                                                            <h4> - </h4>
                                                                                    }
                                                                                </div>
                                                                                :
                                                                                <h4> - </h4>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <h4> - </h4>
                                                            }
                                                        </div>
                                                    ) : <></>}

                                                    {!isChildGroupSubscription() ? (
                                                        <div>
                                                            <span>Next invoice</span>
                                                            <h4> - </h4>
                                                        </div>
                                                    ) : <></>}
                                                </div>
                                                :
                                                <div className='body-section'>
                                                    <div>
                                                        <span>Plan name</span>
                                                        {
                                                            userMembership && (userMembership.role_id === 4 || userMembership.role_id === 3) ?
                                                                <>
                                                                    {userMembership.active_subscription ?
                                                                        <h4>
                                                                            {userMembership.active_subscription.plan.name}
                                                                        </h4>
                                                                        :
                                                                        <div>
                                                                            {
                                                                                userMembership.previous_plan ?
                                                                                    <h4>{userMembership.previous_plan.name}</h4>
                                                                                    :
                                                                                    <h4> - </h4>
                                                                            }

                                                                        </div>
                                                                    }
                                                                </>
                                                                :
                                                                <h4> - </h4>
                                                        }
                                                    </div>
                                                    <div>
                                                        <span>Plan type</span>
                                                        {
                                                            userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                <>
                                                                    {
                                                                        userMembership.active_subscription ?
                                                                            <div>
                                                                                {
                                                                                    userMembership.active_subscription.plan
                                                                                        ?
                                                                                        <h4>{getPlanType(userMembership.active_subscription.plan)}</h4>
                                                                                        :
                                                                                        <h4> - </h4>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                {
                                                                                    userMembership.previous_plan ?
                                                                                        <h4>{getPlanType(userMembership.previous_plan)}</h4>
                                                                                        :
                                                                                        <h4> - </h4>
                                                                                }

                                                                            </div>
                                                                    }
                                                                </>
                                                                :
                                                                <h4> - </h4>
                                                        }
                                                    </div>
                                                    {
                                                        //for parent group subscriptions, show number of seats
                                                        isParentGroupSubscription() ? (
                                                            <div>
                                                                <span>Seats</span>
                                                                <h4>
                                                                    <span
                                                                    className="clickable-value"
                                                                    onClick={() => setIsMembersModalOpen(true)}
                                                                    >
                                                                        {userMembership.sub_accounts_count + 1}
                                                                        {" "}/{" "}
                                                                        {userMembership.active_subscription.quantity}
                                                                    </span>
                                                                </h4>
                                                            </div>
                                                        ) : <></>
                                                    }
                                                    {
                                                        //for parent group subscriptions, show invite link
                                                        isParentGroupSubscription() ? (
                                                            <div>
                                                                <span>Invite link</span>
                                                                <p
                                                                className="clickable-value invite-link"
                                                                onClick={copyGroupSubscriptionInviteLink}
                                                                >
                                                                    {getGroupSubscriptionDisplayInviteLink()}
                                                                </p>
                                                            </div>
                                                        ) : <></>
                                                    }
                                                    {
                                                        //for child group subscriptions, show account owner
                                                        isChildGroupSubscription() ? (
                                                            <div>
                                                                <span>Account owner</span>
                                                                <h4>
                                                                    <span
                                                                    className="clickable-value"
                                                                    onClick={navigateToParentProfile}
                                                                    >{getParentName()}</span>
                                                                </h4>
                                                            </div>
                                                        ) : <></>
                                                    }
                                                    {!isChildGroupSubscription() ? (
                                                        <div>
                                                            <span>Amount</span>
                                                            {
                                                                userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                    <>
                                                                        {
                                                                            userMembership.active_subscription ?
                                                                                <h4>
                                                                                    {miscUtils.getResourceCurrency(userMembership.active_subscription.plan.currency, userMembership.group && userMembership.group.currency)}{" "}
                                                                                    {userMembership.active_subscription.plan.price}
                                                                                </h4>
                                                                                :
                                                                                <div>
                                                                                    {
                                                                                        userMembership.previous_plan ?
                                                                                            <h4>
                                                                                                {miscUtils.getResourceCurrency(userMembership.previous_plan.currency, userMembership.group && userMembership.group.currency)}{" "}
                                                                                                {userMembership.previous_plan.price}
                                                                                            </h4>
                                                                                            :
                                                                                            <h4> - </h4>
                                                                                    }

                                                                                </div>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <h4> - </h4>
                                                            }
                                                        </div>
                                                    ) : <></>}
                                                    <div>
                                                        <span>Status</span>
                                                        {
                                                            userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                <>
                                                                    {
                                                                        userMembership.blocked ?
                                                                            <h4>
                                                                                Blocked
                                                                            </h4>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    userMembership.active_subscription ?
                                                                                        <h4>{userMembership.active_subscription.stripe_status.replace(/_/g, " ")}</h4>
                                                                                        :
                                                                                        <h4> Canceled </h4>
                                                                                }
                                                                            </>
                                                                    }
                                                                </>
                                                                :
                                                                <h4> - </h4>
                                                        }
                                                    </div>
                                                    {!isChildGroupSubscription() ? (
                                                        <div>
                                                            <span>Started</span>
                                                            {
                                                                userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                    <>
                                                                        {
                                                                            userMembership.active_subscription_start_date ?
                                                                                <h4>
                                                                                    {moment.utc(userMembership.active_subscription_start_date).local().format('MMM D, YYYY')}
                                                                                </h4>
                                                                                :
                                                                                <h4> - </h4>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <h4> - </h4>
                                                            }
                                                        </div>
                                                    ) : <></>}
                                                    {!isChildGroupSubscription() ? (
                                                        <div>
                                                            <span>Billing cycle</span>
                                                            {
                                                                userMembership.role_id === 4 || userMembership.role_id === 3 ?
                                                                    <>
                                                                        {
                                                                            userMembership.active_subscription ?
                                                                                <div>
                                                                                    {
                                                                                        userMembership.active_subscription.plan.interval
                                                                                            ?
                                                                                            // <h4>{userMembership.active_subscription.plan.interval.replace(/_/g, " ")}</h4>
                                                                                            <h4>{formatBillingInterval(userMembership.active_subscription.plan)}</h4>
                                                                                            :
                                                                                            <h4> - </h4>
                                                                                    }
                                                                                </div>
                                                                                :
                                                                                <h4> - </h4>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <h4> - </h4>
                                                            }
                                                        </div>
                                                    ) : <></>}
                                                    {!isChildGroupSubscription() ? (
                                                        <>
                                                            {
                                                                userMembership.active_subscription && userMembership.active_subscription.stripe_status && userMembership.active_subscription.stripe_status.includes('on grace') &&
                                                                    (userMembership.role_id === 4 || userMembership.role_id === 3)
                                                                    ?
                                                                    <div>
                                                                        <span>Cancels on</span>

                                                                        <h4>
                                                                            {moment.utc(userMembership.active_subscription && userMembership.active_subscription.ends_on).local().format('MMM D, YYYY')}
                                                                        </h4>

                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <span>Next invoice</span>
                                                                        {
                                                                            (userMembership.role_id === 4 || userMembership.role_id === 3) ?
                                                                                <>
                                                                                    {
                                                                                        userMembership.active_subscription &&
                                                                                            userMembership.active_subscription_end_date &&
                                                                                            userMembership.active_subscription.plan &&
                                                                                            userMembership.active_subscription.plan.type &&
                                                                                            !userMembership.active_subscription.plan.type.includes('one_time')
                                                                                            ?
                                                                                            <h4>
                                                                                                {moment.utc(userMembership.active_subscription_end_date).local().format('MMM D, YYYY')}
                                                                                            </h4>
                                                                                            :
                                                                                            <h4> - </h4>
                                                                                    }
                                                                                </>
                                                                                :
                                                                                <h4> - </h4>
                                                                        }
                                                                    </div>
                                                            }
                                                        </>
                                                    ) : <></>}
                                                </div>

                                        }
                                    </>
                            }
                        </>
                    }
                </>
            }
            {isParentGroupSubscription() ? (
                <GroupSubscriptionMembersModal
                 isOpen={isMembersModalOpen}
                onClose={() => setIsMembersModalOpen(false)}
                group={{
                    id: group && group.id,
                    user_membership: userMembership,
                }}
                parentAccountData={userMembership}
                />
            ) : <></>}
        </div>
        </>
    )
}

export default SubscriptionMemberDetails